/**
 * Document object from API
 */
export interface Document {
  id: string;
  customerId: string;
  filename: string;
  originalFilename: string;
  r2Key: string;
  fileType: string;
  fileSize: number;
  category: DocumentCategory;
  description: string | null;
  uploadedBy: string;
  uploadedByType: "admin" | "customer";
  status: DocumentStatus;
  createdAt: string;
  updatedAt: string;
}

export type DocumentCategory =
  | "id_verification"
  | "income"
  | "bank_statements"
  | "contracts"
  | "other";

export type DocumentStatus = "pending" | "approved" | "rejected";

/**
 * Document category labels
 */
export const documentCategoryLabels: Record<DocumentCategory, string> = {
  id_verification: "ID Verification",
  income: "Income Documents",
  bank_statements: "Bank Statements",
  contracts: "Contracts",
  other: "Other",
};

/**
 * Document status labels and colors
 */
export const documentStatusConfig: Record<
  DocumentStatus,
  { label: string; color: string }
> = {
  pending: { label: "Pending Review", color: "bg-yellow-100 text-yellow-800" },
  approved: { label: "Approved", color: "bg-green-100 text-green-800" },
  rejected: { label: "Rejected", color: "bg-red-100 text-red-800" },
};

/**
 * Upload form data
 */
export interface UploadFormData {
  file: File | null;
  category: DocumentCategory;
  description: string;
}
